"use client";

import { trackPurchaseReturn } from '@/utils/purchase-return';
import { useEffect, useState } from 'react';
import Script from 'next/script';
import { browserAnalyticsSettings } from '@/utils/analytics-browser.mjs';
import { trackLifecycleEvents } from '@/utils/analytics-lifecycle';
import { flushGAEvents } from '@/utils/analytics';
import { returnAnalyticsOptions } from '@/utils/analytics-parameters.mjs';
// Next invokes inline onReady before appendChild executes the initializer.
const flushAfterScriptExecution = () => queueMicrotask(flushGAEvents);

export default function GoogleAnalytics({ tagId }) {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => {
    const settings = browserAnalyticsSettings();
    if (!settings.enabled || settings.tagId !== tagId) return;
    setEnabled({
      ...returnAnalyticsOptions(window.location.href, document.referrer),
      ...(settings.testEnabled ? { debug_mode: true } : {}),
    });
  }, [tagId]);
  useEffect(() => {
    const settings = browserAnalyticsSettings();
    if (!settings.enabled || settings.tagId !== tagId) return;
    const resume = () => { trackPurchaseReturn(); void trackLifecycleEvents(); flushGAEvents(); };
    resume();
    const timer = setInterval(resume, 60000);
    window.addEventListener('focus', resume);
    window.addEventListener('botgo:authenticated', resume);
    return () => { clearInterval(timer); window.removeEventListener('focus', resume); window.removeEventListener('botgo:authenticated', resume); };
  }, [tagId]);
  if (!enabled) return null;
  // Preserve the existing config command and default page_view behavior.
  // Existing general analytics consent behavior is preserved; purchase requires a verified receipt.
  const initialization = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', ${JSON.stringify(tagId)}, ${JSON.stringify(enabled)});
  `;
  return (
    <>
      <Script src={`https://www.googletagmanager.com/gtag/js?id=${tagId}`} strategy="lazyOnload" async onReady={flushAfterScriptExecution} />
      <Script id="google-analytics" strategy="lazyOnload" onReady={flushAfterScriptExecution}>{initialization}</Script>
    </>
  );
}
